import moment from "moment";
import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
const toBn = (n) => n.replace(/\d/g, (d) => "০১২৩৪৫৬৭৮৯"[d]);
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const UserReqSlip = () => {
  const { req_id } = useParams();
  // console.log(req_id);
  const navigate = useNavigate();
  // get doneReqSlip Data
  const {
    data: doneReqSlip,
    error,
    mutate,
  } = useSWR(req_id ? `store/requisition/done/${req_id}` : null, fetcher);
  console.log(doneReqSlip);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <Helmet>
        <title>Requisition Details - BBA STORE</title>
        <meta name="description" content="Requisition Details - BBA STORE" />
      </Helmet>
      {!doneReqSlip ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="page-wrapper">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                className="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i className="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div>
              <button
                onClick={handlePrint}
                type="button"
                className="btn tableColor px-3 printBtn show ms-auto my-3 me-2 "
              >
                <i className="fa fa-print"></i>
                <span> Print</span>
              </button>
            </div>
          </div>

          <section ref={componentRef} className=" mx-3 py-4">
            <div className="my-5">
              {doneReqSlip.userInfo && (
                <>
                  <div className="row">
                    <div className="col-3 col-md-4 col-lg-3"></div>
                    <div className="col-6 col-md-6 col-lg-6 "></div>
                    <div className="col-3 col-md-2 col-lg-3">
                      <h4>
                        এন্ট্রি নং:{" "}
                        {toBn(`${doneReqSlip.userInfo[0].REQUISITIONNO}`)}
                      </h4>{" "}
                      <h4>
                        তারিখ:{" "}
                        {toBn(
                          `${moment(
                            new Date(doneReqSlip.userInfo[0].REQUIDATE)
                          ).format("DD-MM-YYYY")}`
                        )}
                      </h4>
                    </div>
                  </div>

                  <div className="text-center mt-3">
                    <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                    </h4>
                    
                  </div>

                  <div className=" px-2 mt-5 py-4 d-flex justify-content-between">
                    <div>
                      <h4 className="mb-3">
                        চাহিদাকারী কর্মকর্তা /কর্মচারীর নাম:{" "}
                        {doneReqSlip.userInfo[0].NAME_ENGLISH}
                      </h4>
                      <h4>পদবী: {doneReqSlip.userInfo[0].DESIGNATION}</h4>
                    </div>
                    <div>
                      <h4 className="mb-3">
                        শাখা: {doneReqSlip.userInfo[0].DEPARTEMENT}
                      </h4>
                      <h4>
                        নম্বর: {toBn(doneReqSlip.userInfo[0].MOBILE_PHONE)}
                      </h4>
                    </div>
                  </div>
                </>
              )}

              <div className="px-2 my-5">
                <table className="table ">
                  <thead>
                    <tr>
                      <th className="fw-bold col-design">ক্রমিক নং</th>
                      <th className="fw-bold col-design">দ্রব্যর নাম</th>
                      <th className="fw-bold col-design">চাহিদার পরিমান</th>
                      <th className="fw-bold col-design">
                        অনুমোদিত সরবরাহের পরিমাণ
                      </th>
                      <th className="fw-bold col-design">মন্তব্য</th>
                    </tr>
                  </thead>
                  <tbody>
                    {doneReqSlip.products &&
                      doneReqSlip.products.map((product, index) => (
                        <tr key={index}>
                          <td className="col-design">{toBn(`${++index}`)}</td>
                          <td className="col-design">{product.proname}</td>
                          <td className="col-design">
                            {toBn(`${product.prorequqty}`)}
                          </td>
                          <td className="col-design">
                            {toBn(`${product.aproqty}`)}
                          </td>
                          <td className="col-design">{product.premarks}</td>
                        </tr>
                      ))}
                  </tbody>
                  <tbody>
                    {doneReqSlip && (
                      <tr>
                        <td className="col-design"></td>
                        <td className="col-design"></td>
                        <td className="col-design total-design">
                          মোট চাহিদা :{" "}
                          <span className="fw-bold">
                            {toBn(`${doneReqSlip.totalRequQty}`)} টি{" "}
                          </span>
                        </td>
                        <td className="col-design total-design">
                          মোট অনুমোদিত :{" "}
                          <span className="fw-bold">
                            {toBn(`${doneReqSlip.totalAppQty}`)} টি{" "}
                          </span>
                        </td>
                        <td className="col-design"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default UserReqSlip;
